import axios from "axios";
import { Message } from "element-ui";
import router from "../router";
import { projectNameFn } from "@/utils/util.js";
// 本地测试环境
// let commonUrl = "http://192.168.1.107:446";
// 生产环境
let commonUrl = "https://api.weipaidui.xyz";
// let commonUrl = "http://121.199.72.193:446";
// 登录请求方法
const loginreq = (method, url, params) => {
  let text = "";
  let a = 0;

  for (const key in params) {
    if (a == 0) {
      text = text + key + "=" + params[key];
    } else {
      text = text + "&" + key + "=" + params[key];
    }
    a++;
  }

  return axios({
    method: method,
    // url: "http://dljc.youkutongcheng.com"+url+"?"+text,
    // url: "http://dljc.youkutongcheng.com"+url+"?"+text,
    //   url: "http://192.168.1.16:446"+url+"?"+text,
    url: commonUrl + url + "?" + text,
    ders: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }

        return ret;
      }
    ]
  }).then(res => {
    //token失效 返回到首页
    if (res.data.code == 422) {
      console.log("=============1");
      localStorage.removeItem("userInfo");
      Message.error(res.data.msg);
      router.replace({ path: "/login" });
    } else {
      return res.data;
    }
  });
};

// 通用公用方法
const req = (method, url, params) => {
  return axios({
    method: method,
    url: commonUrl + url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: localStorage.getItem(projectNameFn("logintoken"))
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        console.log("data===1===", data);
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }

        return ret;
      }
    ]
  }).then(res => {
    //token失效 返回到首页
    if (res.data.code == 422) {
      console.log("=============1");
      localStorage.removeItem("userInfo");
      Message.error(res.data.msg);
      router.replace({ path: "/login" });
    } else {
      return res.data;
    }
  });
};
// 通用公用方法
const reqGet = (method, url, params) => {
  console.log("params==", params);
  let text = "";
  let a = 0;
  let urls;
  if (params == "" || params == undefined) {
    urls = commonUrl + url;
  } else {
    for (const key in params) {
      if (a == 0) {
        text = text + key + "=" + params[key];
      } else {
        text = text + "&" + key + "=" + params[key];
      }
      a++;
    }
    urls = commonUrl + url + "?" + text;
  }

  return axios({
    method: method,
    // url: "http://dljc.youkutongcheng.com"+url+"?"+text,
    // url: "http://dljc.youkutongcheng.com"+url+"?"+text,
    //   url: "http://192.168.1.16:446"+url+"?"+text,
    url: urls,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: localStorage.getItem(projectNameFn("logintoken"))
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      }
    ]
  }).then(res => {
    //token失效 返回到首页
    if (res.data.code == 422) {
      console.log("=============1");
      localStorage.removeItem("userInfo");
      Message.error(res.data.msg);
      router.replace({ path: "/login" });
    } else {
      return res.data;
    }
  });
};
// JSON传参方法
const reqPostJson = (method, url, params, initialHeaders) => {
  let token = localStorage.getItem(projectNameFn("logintoken"))
  let finalHeaders = {}
  if (token) {
    finalHeaders = {
      ...initialHeaders,
      Authorization: token
    }
  } else {
    localStorage.removeItem("userInfo");
    Message.error(res.data.msg);
    router.replace({ path: "/login" });
    return Promise.reject(new Error("未登录")); // 返回一个拒绝的 Promise
  }
  return axios({
    method: method,
    url: commonUrl + url,
    data: params,
    headers: finalHeaders,
    traditional: true,
    transformRequest: [
      function (data) {
        console.log("data===1===", data);
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }

        return ret;
      }
    ]
  }).then(res => {
    if (res.data.code == 422) {
      console.log("=============1");
      localStorage.removeItem("userInfo");
      Message.error(res.data.msg);
      router.replace({ path: "/login" });
    } else {
      return res.data;
    }
  })
}
export { loginreq, req, reqGet, reqPostJson };



// WEBPACK FOOTER //
// ./src/api/axiosFun.js